/** @jsxImportSource @emotion/react */
import { css, useTheme } from "@emotion/react";
import React from "react";

import { Button } from "@coreai/component-library";
import { t } from "i18next";
import { useLanguage } from "LanguageContext";
import { useNavigate } from "react-router-dom";

interface WelcomeCardProps {
  setNewAnalysis: (set: boolean) => void;
}

export default function WelcomeCard(props: Readonly<WelcomeCardProps>) {
  const theme = useTheme();
  const { t } = useLanguage();

  const navigate = useNavigate();
  const cardStyles = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadows.medium};
    padding: ${theme.spacing["5xl"]};
    text-align: center;
    border-radius: ${theme.radius.xs};
    margin: ${theme.spacing["5xl"]} 0 0 0;
  `;

  const titleStyles = css`
    font-family: ${theme.typography.heading3_medium.fontFamily};
    font-size: ${theme.typography.heading3_medium.fontSize};
    font-weight: ${theme.typography.heading3_medium.fontWeight};
    color: ${theme.colors.textDark};
  `;

  const descriptionStyles = css`
    font-family: ${theme.typography.bodyMedium.fontFamily};
    font-size: ${theme.typography.bodyMedium.fontSize};
    font-weight: ${theme.typography.bodyMedium.fontWeight};
    margin-bottom: ${theme.spacing.xxl};
    line-height: ${theme.typography.bodyMedium.lineHeight};
    color: ${theme.colors.textMedium};
  `;

  const descriptionBoldStyles = css`
    font-family: ${theme.typography.body_semiBold.fontFamily};
    font-size: ${theme.typography.body_semiBold.fontSize};
    font-weight: ${theme.typography.body_semiBold.fontWeight};
    margin-bottom: ${theme.spacing.xxl};
    line-height: ${theme.typography.body_semiBold.lineHeight};
  `;

  return (
    <div css={cardStyles}>
      <div css={titleStyles} dangerouslySetInnerHTML={{__html: t("welcome_title")}} />
      <p css={descriptionStyles} dangerouslySetInnerHTML={{__html: t("welcome_text")}} />
      <Button
        variant={"secondary"}
        size="sm"
        icon={"plus"}
        color={theme.colors.primary}
        onClick={() => navigate(`/analyses/new`)}
      >
        {t("navigation_newCampaign")}
      </Button>
    </div>
  );
}
